<template>
  <div v-if="initialized" class="application">
    <transition name="start" mode="out-in">
      <div v-if="started == false" class="screen top">
        <div class="top">
          <div class="start" @click="start"></div>
          <div class="notes">
            <div class="note"></div>
            <div class="note"></div>
            <div class="note"></div>
          </div>
        </div>
      </div>
      <div v-if="started && (index != null || type)" class="screen">
        <transition :name="transition" mode="out-in">
          <div v-if="index != null && !moving" class="question">
            <div class="question-heading">
              <small>{{ index + 1 }}</small>
              {{ question.title }}
            </div>
            <div class="question-body">
              <div class="question-prev">
                <a v-if="prevQuestion" href="#" @click.prevent="movePrevQuestion">前の設問に<br>戻る</a>
              </div>
              <a href="#" class="question-option yes" @click="answer('yes')">
                <div class="question-option-label">
                  <span class="text">はい</span>
                  <span class="leaf"></span>
                </div>
                <div class="question-option-comment">{{ question.comment.yes }}</div>
                <div class="question-option-face" :class="`face-${question.char_kind.yes}`"></div>
              </a>
              <a href="#" class="question-option no" @click="answer('no')">
                <div class="question-option-label">
                  <span class="text">いいえ</span>
                  <span class="leaf"></span>
                </div>
                <div class="question-option-comment">{{ question.comment.no }}</div>
                <div class="question-option-face" :class="`face-${question.char_kind.no}`"></div>
              </a>
              <div class="question-next">
                <a v-if="nextQuestion" href="#" @click.prevent="moveNextQuestion">次の設問に<br>進む</a>
                <a v-else-if="type" href="#" @click.prevent="moveResult">次の設問に<br>進む</a>
              </div>
            </div>
            <div class="question-footer">
              既に回答済みの番号にカーソルを合わせると設問と回答が表示され、クリックすると戻って再度回答できます
            </div>
          </div>
          <div v-if="index == null && type && !moving" class="result">
            <div class="result-heading">
              <div class="result-title">{{ type.title }}</div>
              <div class="result-lead">{{ type.lead }}</div>
            </div>
            <div class="result-actions">
              <a class="result-print" :href="type.print" target="_blank">印刷</a>
              <a class="result-pdf" :href="type.pdf" target="_blank">PDF</a>
              <a class="result-regist" href="https://forestyle-ryujin.jp/member/members/index" target="_blank">メンバー登録</a>
            </div>
            <div class="result-detail">
              <div class="result-detail-period">
                <dl class="result-detail-period-list">
                  <dt>準備期間</dt><dd>{{ type.jyunbi }}</dd>
                  <dt>設計期間</dt><dd>{{ type.sekkei }}</dd>
                  <dt>工事期間</dt><dd>{{ type.kouji }}</dd>
                  <dt>完成まで</dt><dd>{{ type.all }}</dd>
                </dl>
                <div class="result-detail-period-notice">{{ type.notice }}</div>
              </div>
              <div class="result-detail-answer">
                <div class="result-detail-text" v-html="type.answer"></div>
              </div>
            </div>
            <div class="result-footer">
              番号にカーソルを合わせると設問と回答が表示され、クリックすると戻って再度回答できます
            </div>
          </div>
        </transition>
        <div class="answers">
          <div class="answer" v-for="i in 12">
            <a v-if="answers[i-1]" class="answer-leaf" href="#" @click.prevent="moveQuestion(i-1)">
              <div class="answer-leaf-num">{{ i }}</div>
              <div class="answer-balloon">
                <div class="answer-balloon-title">{{ answers[i-1].question }}</div>
                <div class="answer-balloon-answer">{{ answers[i-1].answer }}</div>
              </div>
            </a>
            <span v-else class="answer-leaf blank"></span>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <div v-else class="application">
    <div class="application-loading">読み込み中</div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState([
      'started',
      'result',
      'index',
      'moving',
      'transition',
    ]),
    ...mapGetters([
      'initialized',
      'screen',
      'question',
      'prevQuestion',
      'nextQuestion',
      'answers',
      'type',
    ]),
  },
  created() {
    this.initialize()
  },
  methods: {
    ...mapActions([
      'initialize',
      'start',
      'answer',
      'movePrevQuestion',
      'moveNextQuestion',
      'moveQuestion',
      'moveResult',
    ]),
  },
}
</script>


// WEBPACK FOOTER //
// assets/js/components/Iekatsu.vue